import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import styles from '../../../styles/components/layout/HeaderSection.module.css';

/**
 * Header Menu Component
 * Displays navigation menu items
 * 
 * @param {Array} menu - Array of menu items
 * @param {Function} onItemClick - Function to call when menu item is clicked
 * @param {String} className - Additional CSS classes
 * @param {String} itemClassName - Additional CSS classes for menu items
 * @param {Boolean} isMobile - Whether this is for mobile layout
 */
const HeaderMenu = ({ menu, onItemClick, className = '', itemClassName = '', isMobile = false }) => {
    const router = useRouter();

    // Function to check if menu item is active
    const isMenuItemActive = menuUrl => {
        const currentPath = router.asPath;
        if (currentPath === menuUrl) return true;
        if (menuUrl === '/' && currentPath === '/') return true;
        return menuUrl !== '/' && currentPath.startsWith(menuUrl);
    };

    if (!menu || menu.length === 0) return null;

    return (
        <ul className={`navbar-nav ${isMobile ? 'ms-auto mb-2 mb-lg-0 mt-3' : 'd-flex flex-row align-items-center mb-0 ml-4'} ${className}`}>
            {menu.map((item, index) => {
                if (!item.isHidden) {
                    const isActive = isMenuItemActive(item.url);
                    return (
                        <li 
                            className={`nav-item ms-2 d-flex align-items-center ${isMobile ? 'justify-content-start' : ''} ${itemClassName}`} 
                            key={index}
                        >
                            <Link 
                                href={item.url} 
                                className={`nav-link ${styles['menu-links']} ${isActive ? styles.isActive : ''}`}
                                onClick={() => onItemClick(item.url)}
                            >
                                {item.name}
                            </Link>
                        </li>
                    );
                }
                return null;
            })}
        </ul>
    );
};

export default HeaderMenu;
